import { COMMON_CONSTANTS } from "src/constants/commonConstants";
import { OfficeTransformedData } from "src/models/office.model";
import commonUtils from "src/utils/common.utils";

import API_URL from "./apiConfig/api.config";
import apiCall from "./apiConfig/apiCall.config";

export async function linkOfficeValidate(
  uuid: string,
  payload: {
    child_office?: string;
    linking: boolean;
  }
) {
  const url = commonUtils.getUrlReplace(
    API_URL.CHILD_OFFICE.LINK_VALIDATE,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}
export async function mergeOfficeValidate(
  uuid: string,
  payload: {
    child_office?: OfficeTransformedData;
    merging: boolean;
    private_office: string;
  }
) {
  const url = commonUtils.getUrlReplace(
    API_URL.CHILD_OFFICE.MERGE_VALIDATE,
    COMMON_CONSTANTS.OFFICE_UUID,
    uuid
  );
  return await apiCall.patch(url, payload);
}
